export const createMeter = `
    mutation createMeter($input: CreateMeterInput!) {
        createMeter(input:$input) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
    }
}`;

export const updateMeter = `
    mutation updateMeter($input: UpdateMeterInput!) {
        updateMeter(input:$input){
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

export const deleteMeter = `
    mutation deleteMeter($input: DeleteMeterInput!) {
        deleteMeter(input:$input)
}`;
